export const DIALOGUE_CARD_TEST_ID = 'DialogueCardTestId';
export const DIALOGUE_CARD_CONTENT_TEST_ID = 'DialogueCardContentTestId';
export const DIALOGUE_CARD_BUTTONS_TEST_ID = 'DialogueCardButtonTestId';
